export default __webpack_public_path__ + "static/media/error.14b75f6c.svg";